export class ValidationType {
    ID: number;
    Name: string;
    Inactive: boolean;
}

export default ValidationType;